import { enUS, trTR } from "@clerk/localizations";

import { type ResolvedUiLanguage } from "~/i18n/locale";

/** Clerk UI strings follow the same resolved language as the rest of MorrowOS. */
export function resolveClerkLocalization(language: ResolvedUiLanguage): typeof enUS {
  return language === "tr" ? trTR : enUS;
}
